import { Box, Card, CardBody, Heading, SimpleGrid, Text } from '@chakra-ui/react'

type DashboardWidgetMetricItem = {
  label: string
  value: string
}

type DashboardWidgetBreakdownItem = {
  label: string
  value: string
}

type DashboardWidgetAttributionSectionProps = {
  title: string
  summaryTitle: string
  initialTitle: string
  lastTitle: string
  summaryItems: DashboardWidgetMetricItem[]
  initialItems: DashboardWidgetBreakdownItem[]
  lastItems: DashboardWidgetBreakdownItem[]
  cardBg: string
  textColor: string
  subtitleColor: string
  statNumberColor: string
  borderColor: string
}

export function DashboardWidgetAttributionSection(
  props: DashboardWidgetAttributionSectionProps
) {
  const {
    title,
    summaryTitle,
    initialTitle,
    lastTitle,
    summaryItems,
    initialItems,
    lastItems,
    cardBg,
    textColor,
    subtitleColor,
    statNumberColor,
    borderColor,
  } = props

  const renderItems = (items: DashboardWidgetMetricItem[]) => (
    <SimpleGrid columns={{ base: 1, sm: 2, xl: 4 }} spacing={{ base: 3, md: 4 }}>
      {items.map((item) => (
        <Box
          key={item.label}
          borderWidth="1px"
          borderColor={borderColor}
          borderRadius="lg"
          p={{ base: 3, md: 3.5 }}
        >
          <Text fontSize="sm" color={subtitleColor}>
            {item.label}
          </Text>
          <Text fontSize="2xl" fontWeight="bold" color={statNumberColor} mt={2}>
            {item.value}
          </Text>
        </Box>
      ))}
    </SimpleGrid>
  )

  return (
    <Card bg={cardBg} borderRadius="xl" boxShadow="sm">
      <CardBody p={{ base: 4, md: 6 }}>
        <Heading size={{ base: 'sm', md: 'md' }} mb={4} color={textColor}>
          {title}
        </Heading>

        <Box mb={{ base: 5, md: 6 }}>
          <Text fontSize="sm" fontWeight="semibold" color={subtitleColor} mb={3}>
            {summaryTitle}
          </Text>
          {renderItems(summaryItems)}
        </Box>

        <SimpleGrid columns={{ base: 1, xl: 2 }} spacing={{ base: 5, md: 6 }}>
          <Box>
            <Text fontSize="sm" fontWeight="semibold" color={subtitleColor} mb={3}>
              {initialTitle}
            </Text>
            {renderItems(initialItems)}
          </Box>

          <Box>
            <Text fontSize="sm" fontWeight="semibold" color={subtitleColor} mb={3}>
              {lastTitle}
            </Text>
            {renderItems(lastItems)}
          </Box>
        </SimpleGrid>
      </CardBody>
    </Card>
  )
}
